import { render, staticRenderFns } from "./importClasse.vue?vue&type=template&id=7923fd2d&"
import script from "./importClasse.vue?vue&type=script&lang=js&"
export * from "./importClasse.vue?vue&type=script&lang=js&"
import style0 from "./importClasse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports